import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Pagination from "../../../../../../../Reuseable/Pagination";
import { useParams, useHistory  } from "react-router-dom";
import axios from "axios";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import cup from "../../../../../../../../assets/images/cup 2.png";


const RegisteredTable = () => {

const [buffer, setBuffer] = useState(true);
const [participantList, setParticipantList] = useState([]);
const [search, setSearch] = useState('');
 const [searchTimeout, setSearchTimeout] = useState(null);
 const inputRef = useRef(null);

  // route matamater id 
  const { id } = useParams();
  let history = useHistory();

  useEffect(() => {
    
      const urlParams = new URLSearchParams(window.location.search);
      const page = urlParams.get('page') || 1;
    
    onPageChange(page, search);

      
  }, [search]);

  useEffect(() => {
    // Focus the input field when the component mounts
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onPageChange = async (page, searchTerm = '') => {
    // setBuffer(true);
      await axios.get(`/api/audition-admin/participant/list/${id}?page=${page}&search=${searchTerm}`, ).then((res) => {
        if (res.data.status === 200) {
          setBuffer(false);
          setParticipantList(res.data.participantList);
          console.log(res.data.participantList);
        }
      });
  }

  const handleSearchChange = async (event) => {
     const value = event.target.value;
     // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set new timeout
    setSearch(value);
    const timeout = setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search);
      history.push(`${window.location.pathname}?${urlParams.toString()}`);
      onPageChange(1, value);
    }, 1000); // Adjust debounce delay as needed

    setSearchTimeout(timeout);
   
  }

   const loveReactToMartConvert = (loveReact = 0) => {
    console.log(loveReact);
    let marks = loveReact / 1000;
    return marks;
  }

  const tableHead = [
    "#SL",
    "Name",
    "Phone",
    "Email",
    "Audition Title",
    "Start - End",
    "React Marks",
    "Status",
  ];

  return (
    <>
     <AllDataHeader title="Register User List" image={cup} count={"Zero"} />
       {buffer ? (
        <LoaderPost />
      ) : (
      <>
        <div className="py-3">
          <h3 className="text-light text-center bg-dark py-3">
            <div className="row">
              <div className="col-md-4">
                <input type="text" 
                  className="form-control bg-dark text-light"
                  name="search" 
                  placeholder="Search Here" 
                  value={search}
                  ref={inputRef}
                  onChange={handleSearchChange}
                 />
              </div>
              <div className="col-md-6">
                
              </div>
            </div>
          </h3>
          <div className="row mx-1" style={{ overflowX: "auto" }}>
            <Table
              className="table w-100"
              striped
              bordered
              hover
              variant="dark"
            >
              <thead>
                <tr>
                  {tableHead &&
                    tableHead.map((heading) => (
                      <th className="bg-warning text-center">{heading}</th>
                    ))}
                </tr>
              </thead>

              <tbody>
                {participantList?.data ? (
                  participantList?.data.map((participant, index) => (
                  
                    <tr>
                      <td>{participant.id}</td>
                      <td>
                        {participant.participant?.first_name}{" "}
                        {participant.participant?.last_name}
                      </td>
                      <td>{participant.participant?.phone}</td>
                      <td>{participant.participant?.email}</td>
                      <td>{participant.audition?.title}</td>
                      <td>
                        {moment(participant.audition?.start_date).format("LL")}{" "}
                        - {moment(participant.audition?.end_date).format("LL")}{" "}
                      </td>
                      <td>{loveReactToMartConvert(participant?.total_love_react[0]?.react_num)}</td>
                      <td>
                        {/* {participant.accept_status === 1
                        ? "Accepted"
                        : "Rejected"} */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <h3 className="text-danger">No Data Found</h3>
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div id="react-paginate">
          {participantList?.data && (
            <Pagination links={participantList.links} onPageChange={onPageChange} />
          )}
        
        </div>
      </>
      )}
    </>
  );
};

export default RegisteredTable;
